import { render, staticRenderFns } from "./ai_bulk_address_review.vue?vue&type=template&id=600e68ec&scoped=true"
import script from "./ai_bulk_address_review.vue?vue&type=script&lang=js"
export * from "./ai_bulk_address_review.vue?vue&type=script&lang=js"
import style0 from "./ai_bulk_address_review.vue?vue&type=style&index=0&id=600e68ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600e68ec",
  null
  
)

export default component.exports